var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCalendarTodoLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 0.666992V2.00033H10.0007V0.666992H11.334V2.00033H14.0007C14.3689 2.00033 14.6673 2.29881 14.6673 2.66699V13.3337C14.6673 13.7019 14.3689 14.0003 14.0007 14.0003H2.00065C1.63246 14.0003 1.33398 13.7019 1.33398 13.3337V2.66699C1.33398 2.29881 1.63246 2.00033 2.00065 2.00033H4.66732V0.666992H6.00065ZM13.334 7.33366H2.66732V12.667H13.334V7.33366ZM5.33398 9.33366V10.667H4.00065V9.33366H5.33398ZM12.0007 9.33366V10.667H6.66732V9.33366H12.0007ZM4.66732 3.33366H2.66732V6.00033H13.334V3.33366H11.334V4.66699H10.0007V3.33366H6.00065V4.66699H4.66732V3.33366Z",
    fill: "#6F7A76"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarTodoLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar-todo-line.f961c0f6.svg";
export { ForwardRef as ReactComponent };